import {
	Button,
	Grid,
	Typography,
	List,
	ListItem,
	IconButton,
	ListItemAvatar,
	Avatar,
	ListItemText,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";

import React, { ChangeEvent, useEffect } from "react";

interface IMailexUploadStepProps {
	files: File[];
	setFiles: (files: File[]) => void;
	validate: (value: boolean) => void;
}

export const MailexUploadStep: React.FC<IMailexUploadStepProps> = ({
	files,
	setFiles,
	validate,
}) => {
	const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
		if (!event.target.files) {
			return;
		}
		setFiles([...files, event.target.files[0]]);
	};

	const handleFileRemove = (name: string) => {
		setFiles(files.filter((file) => file.name !== name));
	};

	useEffect(() => {
		if (files && files.length > 0) validate(true);
		else validate(false);
	}, [files, validate]);

	return (
		<>
			<Grid container display={"flex"} flexDirection={["row", "row-reverse"]}>
				<Grid item md={6} sm={12}>
					<Button variant="outlined" component="label">
						Upload File
						<input
							type="file"
							accept=".zip"
							hidden
							onChange={handleFileUpload}
						/>
					</Button>
				</Grid>
				<Grid item md={6} sm={12}>
					<Typography variant="h6" component="div">
						Uploaded files
					</Typography>
					<List>
						{files.map((file, index) => {
							return (
								<ListItem
									key={`file-upload-mailex-${index}`}
									secondaryAction={
										<IconButton
											onClick={() => handleFileRemove(file.name)}
											edge="end"
											aria-label="delete"
										>
											<DeleteIcon />
										</IconButton>
									}
								>
									<ListItemAvatar>
										<Avatar>
											<FolderIcon />
										</Avatar>
									</ListItemAvatar>
									<ListItemText primary={file.name} secondary={file.type} />
								</ListItem>
							);
						})}
					</List>
				</Grid>
			</Grid>
		</>
	);
};
